import { isNil } from "lodash";
import { useParams } from "react-router-dom";
import PageLayout from "../../../components/common/page-layout";
import EditTestOrderForm from "../../../components/test-orders/edit-test-order-form";
import { RequireAuth } from "../../../hooks/use-auth";

/** Route page for editing one test order. */
const TestOrderEditPage = () => {
  const { uuid } = useParams();
  return (
    <RequireAuth>
      <PageLayout maxWidth={false} title="Edit test order">
        {!isNil(uuid) && typeof uuid === "string" && (
          <EditTestOrderForm testOrderUuid={uuid} />
        )}
      </PageLayout>
    </RequireAuth>
  );
};

export default TestOrderEditPage;
